import React, { useEffect } from "react";
import routeVariants from "../../assets/animates/routeVariants";
import NavbarTop from "../global/NavbarTop";
import { motion } from "framer-motion";
import CustomerStoriesCompanies from "./CustomerStoriesCompanies";
import CustomerStoriesFooter from "./CustomerStoriesFooter";
import Footer from "../global/Footer";
import NavbarBottom from "../global/NavbarBottom";
import ic_location from "../../assets/images/pictures/icon/ic_location_30px.svg";
import ic_person from "../../assets/images/pictures/icon/ic_2_person_30px.svg";
import ic_circle_checked from "../../assets/images/pictures/icon/ic_circle_checked_30px.svg";
import ic_big_person_circle from "../../assets/images/pictures/icon/ic_2_person_big_circle_64px.svg";
import { useTranslation } from "react-i18next";
import bankas from "../../assets/images/logos/customer/bankas_2.png";
import { Link } from "react-router-dom";

const CustomerStoriesFinancingBank = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = "General Financing Bank | GoPaperless";
  });

  return (
    <>
      <NavbarTop />
      <motion.div
        variants={routeVariants}
        initial="initial"
        animate="final"
        id="content"
        className="fs-navigation-overlay-content fs-navigation-overlay-left-content fs-navigation__0 no-transform"
      >
        <div className="container-fluid bg-color">
          <div className="row text-center">
            <div className="col-md-12 intro  text-center">
              <img
                width="64"
                height="64"
                src={ic_big_person_circle}
                alt=""
                decoding="async"
                loading="lazy"
                data-no-retina=""
              />
              <h1 className="why-head mb-25" data-sr="no reset">
                {t("customer.title")}
              </h1>
              <div className="text-center text-subhead" data-sr="no reset">
                <p>{t("customer.note1")}</p>
              </div>
            </div>
          </div>
        </div>
        <div id="eids">
          <div className="container mt-md-m50">
            <div className="row">
              <div className="col-sm-10 col-sm-offset-1">
                <div className="panel">
                  <div className="panel-body box">
                    <div className="col-md-4">
                      <div className="ic-box text-center">
                        <img
                          width="189"
                          height="138"
                          src={bankas}
                          className="img-responsive"
                          alt=""
                          decoding="async"
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <div className="col-md-8">
                      <p>
                        {t("customer.bankas.note1")}
                        <a
                          href="https://www.gfbankas.lt/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          {" "}
                          GENERAL FINANCING BANK
                        </a>{" "}
                        {t("customer.bankas.note3")}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="panel">
                  <div className="panel-body box">
                    <div className="col-md-4">
                      <div className="flex column-wrapper gap-15 pt-10">
                        <div className="flex gap-15">
                          <div>
                            <img src={ic_location} alt="" />
                          </div>
                          <div>
                            <p className="font-weight-bold mx-auto">
                              {t("customer.bankas.note4")}
                            </p>
                            <p className="font-14">
                              {t("customer.bankas.note5")}
                            </p>
                          </div>
                        </div>
                        <div className="flex gap-15">
                          <div>
                            <img src={ic_person} alt="" />
                          </div>
                          <div>
                            <p className="font-weight-bold mx-auto">
                              {t("customer.bankas.note6")}
                            </p>
                            <p className="font-14">
                              {t("customer.bankas.note7")}
                            </p>
                          </div>
                        </div>
                        <div className="flex gap-15">
                          <div>
                            <img src={ic_circle_checked} alt="" />
                          </div>
                          <div>
                            <p className="font-weight-bold mx-auto">
                              {t("customer.bankas.note8")}
                            </p>
                            <p className="font-14">
                              {t("customer.bankas.note9")}
                            </p>
                            <p className="font-14">
                              {t("customer.bankas.note10")}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-8">
                      <p>
                        <em>{t("customer.bankas.note11")}</em>
                      </p>
                      <p>{t("customer.bankas.note12")}</p>
                      <h2>{t("customer.bankas.note13")}</h2>
                      <p>{t("customer.bankas.note14")}</p>
                      <p>{t("customer.bankas.note15")}</p>
                      <p>{t("customer.bankas.note16")}</p>
                      <h2>{t("customer.bankas.note17")}</h2>
                      <p>{t("customer.bankas.note18")}</p>
                      <p>{t("customer.bankas.note19")}</p>
                      <p>{t("customer.bankas.note20")}</p>
                      <h2>{t("customer.bankas.note21")}</h2>
                      <p>{t("customer.bankas.note22")}</p>
                      <p>{t("customer.bankas.note23")}</p>
                      <p>{t("customer.bankas.note24")}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <CustomerStoriesCompanies currentPage="financing" />
        <div className="container security-footer">
          <div className="row">
            <div className="col-sm-8 col-sm-offset-2 text-center mb-60">
              <h1>{t("customer.note17")}</h1>
              <p>{t("customer.note18")}</p>
              <Link
                to="/case-studies"
                className="btn-primary"
                target="_blank"
                rel="noreferrer"
              >
                {t("customer.note19")}
              </Link>
            </div>
          </div>
        </div>
        <CustomerStoriesFooter />
        <Footer />
        <NavbarBottom />
      </motion.div>
    </>
  );
};

export default CustomerStoriesFinancingBank;
